import React, { Component } from 'react';
import ProjectCard from './ProjectCard';
import { projects, categories } from '../data/projects';

class TimeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: 'all'
    };
  }


  filterProjects = (category) => {
    if (category === 'all') return projects;
    return projects.filter(project => project.category === category);
  }

  render() {
    const { selectedCategory } = this.state;
    const filteredProjects = this.filterProjects(selectedCategory);

    const containerStyle = {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    };

    const headerStyle = {
      color: '#1f2937',
      margin: 0,
      fontSize: '32px',
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: '40px'
    };

    const filterBarStyle = {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '40px',
      flexWrap: 'wrap',
      gap: '10px'
    };

    const filterButtonStyle = (isActive) => ({
      padding: '8px 20px',
      border: 'none',
      borderRadius: '25px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      backgroundColor: isActive ? '#2563eb' : '#f3f4f6',
      color: isActive ? 'white' : '#6b7280'
    });

    const projectGridStyle = {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '25px',
      marginTop: '30px'
    };

    return (
      <div style={containerStyle}>
        <h1 style={headerStyle}>Project Gallery</h1>
        
        {/* Filter Bar */}
        <div style={filterBarStyle}>
          {categories.map(category => (
            <button
              key={category}
              style={filterButtonStyle(selectedCategory === category)}
              onClick={() => this.setState({ selectedCategory: category })}
              onMouseOver={(e) => {
                if (selectedCategory !== category) {
                  e.target.style.backgroundColor = '#e5e7eb';
                }
              }}
              onMouseOut={(e) => {
                if (selectedCategory !== category) {
                  e.target.style.backgroundColor = '#f3f4f6';
                }
              }}
            >
              {category === 'all' ? 'All Projects' : category}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div style={projectGridStyle}>
          {filteredProjects.map(project => (
            <ProjectCard 
              key={project.id} 
              project={project}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default TimeView;
